import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {toast, ToastContainer} from 'react-toastify';

const Sale = () => {

  const navigate = useNavigate();

  const [sale, setSale] = useState({
    id: 0,
    name: "",
    mobile: "",
    products: [
    ],
    subtotal: 0,
    gstamount: 0,
    billamount: 0
  });

  const [saleproducts, setSaleproducts] = useState([]);

  const [products, setProducts] = useState([{
    productid: 0,
    name: "",
    price: 0,
    quantity: 0,
    subtotal: 0,
    gstpercent: 0,
    gstamount: 0,
    total: 0,
  }
  ]);

  // function loadData() {
    
  //   setSale(
  //     {
  //       id: 0,
  //       name: "",
  //       mobile: "",
  //       products: [
  //       ],
  //       subtotal: 0,
  //       gstamount: 0,
  //       billamount: 0
  //     }
  //   )

  // }

  useEffect(() => {
    axios.get("https://653cb488d5d6790f5ec82dfd.mockapi.io/api/v1/products")
      .then((res) => {
        setSaleproducts(res.data);
      })
    

  }, []);

  useEffect(() => {
    let subtotal = 0;
    let gstamount = 0;
    let billamount = 0;

    products.forEach((product) => {
      subtotal += product.subtotal;
      gstamount += product.gstamount;
      billamount += product.total;
    })
    subtotal =Math.round(subtotal);
    gstamount = Math.round(gstamount);
    billamount = Math.round(billamount);
    console.log(subtotal, gstamount, billamount)
    setSale({ ...sale, subtotal: subtotal, gstamount: gstamount, billamount: billamount, products: products });

  }, [products])


  function handleChangeProduct(e, i) {
    e.preventDefault();

    let currentProducts = [...products];
    currentProducts[i].productid = 0;
    currentProducts[i].name = "";
    currentProducts[i].price = 0;
    currentProducts[i].quantity = 0;
    currentProducts[i].subtotal = 0;
    currentProducts[i].gstpercent = 0;
    currentProducts[i].gstamount = 0;
    currentProducts[i].total = 0;

    saleproducts.forEach((product) => {
      if (product.id === e.target.value) {
        currentProducts[i].productid = product.id;
        currentProducts[i].name = product.name;
        currentProducts[i].price = product.price;
        currentProducts[i].gstpercent = product.gstpercent;
      }
    });
    setProducts(currentProducts);
  }

  function addProduct(e) {
    e.preventDefault();
    let currentProducts = [...products];
    currentProducts.push({
      productid: 0,
      name: "",
      price: 0,
      quantity: 0,
      subtotal: 0,
      gstpercent: 0,
      gstamount: 0,
      total: 0,
    });
    setProducts(currentProducts);
  }


  function handleChange(e) {
    e.preventDefault();
    setSale({ ...sale, [e.target.id]: e.target.value });

  }

  function handleChangequantity(e, i) {
    e.preventDefault();
    let currentProducts = [...products];
    currentProducts[i].quantity = e.target.value;
    currentProducts[i].subtotal = currentProducts[i].price * currentProducts[i].quantity;
    currentProducts[i].gstamount = currentProducts[i].subtotal * (currentProducts[i].gstpercent / 100);
    currentProducts[i].total = currentProducts[i].subtotal + currentProducts[i].gstamount;
    setProducts(currentProducts);
  }

  
  function save(e) {
    e.preventDefault();
    axios.post('https://653cb488d5d6790f5ec82dfd.mockapi.io/api/v1/sales', sale)
      .then((res) => {
        toast.success('Successfully created!');
        
        navigate(`/admin/print/${sale.id}`  );

        // setSale({
        //   id: 0,
        //   name: "",
        //   mobile: "",
        //   products: [
        //   ],
        //   subtotal: 0,
        //   gstamount: 0,
        //   billamount: 0
        // })
      });
  }

  return (
    <>
        <ToastContainer/>
      <main id="main" className="main">
        <div className="pagetitle ">
          <h1 className=''>Sale</h1>
        </div>
        <div className="row g-3 mt-2">
          <div className="card container col-lg-12">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-6">
                  <label className="form-label">Name</label>
                  <input type="text" className="form-control" id="name" value={sale.name} onChange={(e) => { handleChange(e) }} />
                </div>
                <div className="col-6">
                  <label type="tel" className="form-label" >Mobile</label>
                  <input type="number" className="form-control" id="mobile" value={sale.mobile} onChange={(e) => { handleChange(e) }} />
                </div>
              </div>
            </div>
          </div>
          <div className="card container col-lg-12">
            <div className="card-body ">
              <div className="row col-12">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">No</th>
                      <th scope="col">Product</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Subtotal</th>
                      <th scope="col">GST Amount</th>
                      <th scope="col">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      products.map((item, i) => {
                        
                        return (
                          <tr key={i}>
                            <th scope="row">{i + 1}</th>
                            <th scope="row">
                              <select value={item.productid} onChange={(e) => { handleChangeProduct(e, i) }} className='form-control'>
                                <option value="0">Product</option>
                                {
                                  saleproducts.map((product, j) => {
                                    return (
                                      <option key={j} id={product.id} value={product.id}>{product.name}</option>
                                    )
                                  }
                                  )}
                              </select>
                            </th>
                            <th scope="row ">
                              <input type="number" className="form-control " onChange={(e) => { handleChangequantity(e, i) }} value={item.quantity} id="quantity" />
                            </th>
                            <th scope="row">
                              {item.price}
                            </th>
                            <th scope="row" id="gstamount" >
                              {item.gstamount}
                            </th>
                            <th scope="row" id="total" >
                              {item.total}
                            </th>
                          </tr>
                        )
                      })}
                  </tbody>
                  <tfoot className='table-dark'>
                    <tr>
                      <th scope="col">Total</th>
                      <th scope="col"></th>
                      <th scope="col"></th>
                      <th scope="col">{sale.subtotal}.00</th>
                      <th scope="col">{sale.gstamount}.00</th>
                      <th scope="col">{sale.billamount}.00</th>
                    </tr>
                  </tfoot>
                </table>

                <div className="d-flex justify-content-end">
                  <button type="button" className="btn btn-secondary" onClick={(e) => { addProduct(e) }}>Add</button>
                </div>

              </div>
            </div></div>



          <div className="text-center">
            <button type="submit" className="btn btn-primary" onClick={(e) => { save(e) }}>Save</button>
          </div>
        </div>



      </main>
    </>
  )
}

export default Sale